const React = require("react");
const { useParams } = require("react-router-dom");
const { usePrintful } = require("../context/PrintfulContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingSupplierProducts = () => { const { supplierId } = useParams(); const { t } = usePrintful(); return h(ProductCollectionPage, { supplierId, title: t("h_pf_supplier_products", "Supplier products"), description: t("h_pf_supplier_products_desc", "Designed products available in this Printful store.") }); };
module.exports = { DropshippingSupplierProducts };
